import React, { useLayoutEffect, useState, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  Format,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox, SelectBox, DateBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { assetService } from "../../../apis/apiServices/Asset";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@iconify/react";
import { AssetStatusService } from "../../../apis/apiServices/AssetStatus";
import { maintenanceService } from "../../../apis/apiServices/Maintenance";

export default function MaintComponent() {
  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Scrap";
  }, []);
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [MaintType, setMaintType] = useState([]);
  const [MaintList, setMaintList] = useState([]);
  const [AssetList, setAssetList] = useState([]);
  const [AssetStatusList, setAssetStatusList] = useState([]);
  const [Maintenance, SetMaintenance] = useState({
    id: 0,
    assetId: 0,
    AssetName: "",
    actionDate: null,
    startDate: null,
    endDate: null,
    maintTypeId: 0,
    maintype: "",
    assignedTo: "",
    StatusId: 0,
    StatusName: "",
    remarks: "",
    isActive: true,
  });

  const getAssetSubGroupList = async () => {
    try {
      const Assetresponse = await assetService.getassetDrop();
      setAssetList(Assetresponse?.data);
      const response = await AssetStatusService.getAssetStatus();
      setAssetStatusList(response?.data);
      const dropresponse = await maintenanceService.getMaintenanceDrop();
      setMaintType(dropresponse?.data);
      const maintresponse = await maintenanceService.getMaintenanceList();
      setMaintList(maintresponse?.data);
    } catch (error) {
      console.log("Error fetching Asset List", error);
    }
  };

  useEffect(() => {
    getAssetSubGroupList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const newErrors = {};
    try {
      let body = {
        id: Maintenance.id,
        assetId: Maintenance.assetId,
        actionDate: Maintenance?.actionDate || null,
        startDate: Maintenance?.startDate || null,
        endDate: Maintenance?.endDate || null,
        assignedTo: Maintenance?.assignedTo || "",
        maintTypeId: Maintenance?.maintTypeId || 0,
        StatusId: Maintenance?.StatusId || 0,
        remarks: Maintenance?.remarks || "",
        isActive: Maintenance?.isActive || false,
        ModifiedBy: 0,
      };
      const response = await maintenanceService.addMaintenance(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setIsSubmitted(false);
        return;
      }

      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        navigate(("/Maint", { replace: true }));
        closeModal();
      });
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    SetMaintenance({
      assetId: 0,
      name: "",
      uomId: 0,
      isActive: true,
    });
  };

  const handleInputChange = async (e, field) => {
    SetMaintenance((prev) => ({
      ...prev,
      [field]: e.value,
    }));


  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div>
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };
  const handleRowClick = (e) => {
    SetMaintenance({
      id: e.data.id,
      assetId: e.data.assetId,
      AssetName: e.data.AssetName,
      actionDate: e.data.actionDate,
      startDate: e.data.startDate,
      endDate: e.data.endDate,
      maintTypeId: e.data.maintTypeId,
      maintype: e.data.maintype,
      assignedTo: e.data.assignedTo,
      StatusId: e.data.StatusId,
      StatusName: e.data.StatusName,
      remarks: e.data.remarks,
      isActive: e.data.isActive,

    });
  };
  const handledelete = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "", "success");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  const onCellPrepared = (e) => {
    if (e.rowType === "header") {
      e.cellElement.style.backgroundColor = "#595959"; // #808080
      e.cellElement.style.color = "White";
    } else {
      e.cellElement.style.color = "#353839";
    }
  };
  return (
    <>

    </>
  );
}
